import {useCallback, useEffect, useState} from 'react';
import {useInstance} from 'react-ioc';
import {Link, useNavigate} from 'react-router-dom';
import cn from 'classnames'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import {observer} from 'mobx-react-lite';

import {INDEX, QUIZ, RESULT_NO_TIME} from '../../config/routes';
import {Store} from '../../model/store/Store';

import logo from './S7-Technics_Logo.svg';

import cls from './Header.module.scss';

dayjs.extend(relativeTime)
dayjs.extend(duration)

const Header = observer(() => {

    const {auth} = useInstance(Store)

    const calcDate  = useCallback(() => dayjs.duration((dayjs(auth.createdAt).add(15, 'minutes').unix() - dayjs().unix()) * 1000), [auth.createdAt])

    const navigate = useNavigate();
    const [time, setTime] = useState(calcDate());
    useEffect(() => {
        const interval = setInterval(() => setTime(calcDate()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, [calcDate]);

    useEffect(() => {
        if (auth.result === null && auth.auth && time.asMilliseconds() < 0) {
            auth.clearState()
            navigate(RESULT_NO_TIME)
        }
    }, [time, auth, navigate])

    return (
        <div className={cls.header}>
            <div className={cn(['content', cls.content])}>
                <div className={cls.logo}>
                    <Link to={INDEX}>
                        <img src={logo} alt={'Only Cash Logo'}/>
                    </Link>
                </div>
                <div className={cls.menu}>
                    {auth.auth &&
                        <>
                            <Link to={QUIZ}>📧 {auth.email}</Link>
                            <Link to={QUIZ}>✅ {auth.trying}/3</Link>
                            <Link to={QUIZ}>🕓 {auth.result === null ? time.format('mm:ss') : '--:--'}</Link>
                        </>
                    }
                </div>
            </div>
        </div>
    )
})

export default Header;